export default {
  common: {
    confirm: "確認",
    cancel: "キャンセルする",
    search: "検索",
    save: '保存',
    delete: "削除",
    edit: "編集",
    more: "さらに表示",
    loading: "読み込み中...",
    noData: "データがありません",
    follow: "フォロー",
    alreadyFollow: "フォロー済み",
    openAppDetails: "アプリで詳細確認",
    noDataTip: "データがありません",
    close: "閉じる",
    know: "了解",
    end: "内容は以上です",
    scores: "スコア"
  },
  error: {
    serverError: "サーバーエラーが発生しました、しばらくしてから再試行してください",
    notFound: "ページが見つかりません"
  },
  // 卡组分享页
  deckShare: {
    card_count: "枚",
    player_count: "参加者 {count} 名",
    player: "選手",
    locale_participate: "参戦",
    scanQR: "QRコードをスキャンしてこのデッキを確認する",
    pm_deck_details_diagnosis_result_details: "AI分析結果をチェック"
  },
  // 应用推广
  appPromotion: {
    logoAlt: "カドラバ",
    openApp: "アプリを開く",
    downloadApp: "download",
    cardTrade: "カード取引",
    topDeck: "上位入賞デッキ",
    priceEvaluation: "オークション＆鑑定代行",
    cardCommunity: "トレカ専用のコミュニティ",
    gameTeaching: "回し方徹底解説"
  },
  // 银行卡添加
  addBankCard: {
    cardNumber: "カード番号",
    expirationDate: "有効期限",
    cvv: "CVVを入力",
    cvvTip: "桁数",
    submit: "追加を確認する",
    support: "以下のクレジットカードがご利用いただけます",
    safeTip: "お客様の情報は暗号化され、安全に保護されています",
    confirm: "確定する",
    dateTip: "有効期限を選択してください",
    cardTip: "クレジットカード番号を入力してください",
    unsupportedCard: "このカードは利用できません",
    pm_card_bind_error_expired: "カードの有効期限が切れています",
    pm_card_bind_tip_card_number_length: "カード番号は通常15桁、16桁、または19桁の数字です",
    pm_card_bind_tip_cvv_length: "セキュリティコードは3~4桁の数字です",
    pm_card_bind_security_code_title: "セキュリティコード"
  },
  // 个人主页
  userProfile: {
    userId: "ユーザーID: {id}",
    gameTags: "カテゴリータグ",
    stats: {
      decks: "デッキ",
      followers: "フォロワー",
      following: "フォロー",
      posts: "投稿"
    }
  },
  // 卡包分享
  packShare: {
    increaseList: "上昇幅ランキング",
    rating: "鑑定",
    reviews: "コメント{count} ",
    including: "カードを含む",
    cardPriceFrom: "から",
    cards: "カード枚数{count}",
    sharePack: "カードパックをシェア"
  },
  // 卡片详情页
  cardDetail: {
    increaseList: "値上りランキング",
    products: '商品',
    effectQA: "効果/Q&A",
    decks: "デッキ",
    reviews: "評価",
    other: "その他",
    priceGuarantee: "適正価格保証",
    lastMonth: "直近1ヶ月",
    appDetail: "詳細はアプリでご確認ください",
    condition: "狀態",
    priceTrade: "カドラバ相場",
    priceTrend: {
      up: "上昇",
      down: "下落"
    },
    currentPrice: "現在の価格",
    series: "シリーズ"
  },
  // 分享
  share: {
    priceTrend: "価格の推移",
    strategyInfo: "攻略情報",
    deckConstruction: "デッキ構築",
    appDetail: "詳細はアプリでご確認ください",
    scanQR: "QRコードをスキャンして詳細をチェックしよう〜",
    cardEverything: "トレカに関するすべてがここに集まる"
  },
  // 店铺
  shop: {
    userId: "ユーザーID: {id}",
    products: '商品',
    buyers: "購入者",
    followers: "フォロワー",
    onSale: "出品中の商品",
    sellerCredit: "信用レベル",
    averageDeliveryTime: "平均発送時間"
  },
  // 心愿单
  wish: {
    wishList: "ウィッシュリスト",
    wishCount: "枚",
    wishTips: "今すぐ購入してバトルしよう！"
  },
  // 卡册
  cardAlbum: {
    hi: "Hi, 私は{username}",
    desc: "これはカドラバで私が持っているカードファイルだよ〜",
    cardCount: "所持カード数",
    totalInvestment: "彼の総投入",
    currentExchangePrice: "現在のカドラバ相場の総額",
    syncTitle: "カドラバで一緒にカードをコレクションして図鑑を完成させよう~",
    startExchange: "カドラバの旅を始めよう",
    totalRevenue: "累計収益",
    totalAssets: "総資産",
    totalCards: "カード総数",
    totalGraded: "鑑定済み枚数",
    priceLabel: "カドラバ相場",
    stock: "在庫",
    scanQR: "QRコードで詳細を確認"
  },
  // 动态
  dynamic: {
    comments: "コメント",
    game: "カテゴリー",
    likes: "いいね",
    views: "閲覧",
    includes: "含む",
    view_reply_count: "確認",
    reply_count: "件",
    reply: "返信",
    author: "投稿者",
    scanQR: "QRコードをスキャンしてこの投稿を確認する",
    hot: "人気度"
  },
  activity: {
    // 报名申请
    pleaseSelectGame: "カテゴリを選択してください",
    cardCarvingContent: "シャドーボックス作品紹介",
    privacyNotice: "ご提供いただいた個人情報は、「シャドーボックス大会」関連の目的に限定して使用いたします。\nカドラバは個人情報の関連法規に基づき、最高レベルの技術的および管理的措置を講じ、皆様の個人情報の安全を確実に守ります。",
    pleaseFill: "を入力してください",
    signupRecord: "エントリー履歴",
    shareIntroduction: "作品紹介や制作エピソードをみんなにシェアしませんか~",
    submit: "エントリーする",
    signupRecordEmpty: "エントリー履歴がありません",
    selectGame: "カテゴリを選択してください",
    selectGameTips: "各カテゴリは一度のみエントリー可能です",
    alreadySignup: "エントリー済み",
    game: "カテゴリ",
    name: "名前",
    phone: "携帯電話番号",
    wechat: "LINE ID",
    email: "メールアドレス",
    pleaseFillAll: "未入力の項目があります",
    signupSuccess: "エントリー完了",
    allSignup: "すでに全てエントリー済み",
    inviteDesc: "今すぐカドラバにログインして、この作品を応援しよう～",
    // 邀请注册
    inviteinfo: "{username}からカドラバへの招待がきました。{username}のシャドーボックス作品に投票しましょう！",
    userAgreement: "サービス利用規約",
    privacyPolicy: "プライバシーポリシー",
    and: "および",
    agreementText: "利用規約およびプライバシーポリシーに同意の上、登録情報を送信してください",
    googleLogin: "Googleでログイン",
    appleLogin: "Appleでログイン",
    downloadGoogleTip: "カドラバダウンロードしてGoogleアカウント登録すれば投票権利もらえます～",
    downloadAppleTip: "カドラバダウンロードしてAppleアカウント登録すれば投票権利もらえます～",
    selectArea: "地域を選んでください",
    userAlreadyRegistered: "このユーザーはすでに登録済み、または他のユーザーに招待されています~",
    loginSuccess: "登録成功",
    loginFailed: "登録失敗",
    inviteTip: "カドラバダウンロードして登録すれば投票権利{count}回もらえます～",
    // 作品详情
    userIdLabel: "カドラバID: ",
    currentRank: "現在の順位",
    currentVotes: "現在の投票数",
    votesUnit: '票',
    gapToPrevious: "前の順位まであと",
    workIntroduction: "作品紹介",
    shareAndCanvass: "シェア",
    vote: "投票する",
    // 投票模块
    invite: "招待状",
    uploadWork: "作品アップロード",
    signup: "大会にエントリーする",
    inviteTitle: "中日シャドーボックス国際招待大会エントリー受付中…",
    inviteSubTitle: "今すぐエントリーして、作品でTCG界隈を驚かせよう！",
    voteRank: "投票ランキング",
    voteCount: "保有投票数",
    voteDetail: "投票数の詳細",
    inviteRecord: "招待履歴",
    voteCountTip: "獲得した投票権の有効期限は48時間となります",
    voteRecord: "投票履歴",
    inviteFriend: "友達を招待して投票に参加しよう",
    inviteFriendDescription: "友達の招待登録が完了しましたら、投票権利",
    getVoteCount: "回もらえます～",
    inviteFriendButton: "招待する",
    rank: "{rank}ランキング",
    // 票数详情弹窗
    currentValidVotes: "現在の有効投票数",
    expiredVotes: "期限切れの無効投票数",
    voteNotice: "投票数は取得から{hours}時間で有効期限が切れ、自動的に失効します。お早めにご投票ください！",
    // 投票弹窗
    voteModalTitle: "投票数を選択する",
    remainingVotes: "残り{count}票",
    insufficientVotes: "票数が不足しているため、投票できません",
    voteSuccess: "投票に成功しました",
    voteFailed: "投票に失敗しました",
    // 邀请记录
    inviteSummary: "招待に成功した人数：",
    inviteSummaryCount: '人，',
    inviteSummaryVotes: "獲得合計",
    invitePending: "ログイン待ち",
    inviteSuccess: "招待に成功しました",
    inviteExpired: "無効",
    inviteUnknown: "不明です",
    // 无票弹窗
    noVoteModalTitle: "票がもうありません～",
    inviteFriendToVote: "友達を招待して投票に参加する",
    // 查看排名记录
    checkRankRecord: "{rank}のランキング記録を確認する",
    checkRankRecordShow: "{rank}ランキング",
    inviteDesc2: "シャドーボックス大会があなたを待ってる！"
  },
  // 特商法
  specialLaw: {
    companyInfo: "ショップ運営者情報",
    companyAddress: "所在地",
    officialWebsite: "ホームページ",
    companyEmail: "メールアドレス",
    companyPhone: "電話番号",
    legalName: "責任者",
    productPrice: "販売価格について",
    productPriceDisplay: '販売価格・送料は各商品ページに表示された金額（表示価格/消費税込）とします',
    paymentMethod: "支払い方法",
    creditCard: 'クレジットカード（即時決済）',
    paymentTiming: "支払い時期",
    creditCardTiming: 'クレジットカード：即時決済',
    shippingTiming: "発送時期",
    shippingTimingDesc: '支払い完了後 {time} （特別な取り決めがある場合は、最短期間を適用）',
    deliveryPeriod: "配送期間",
    deliveryPeriodDesc: '発送後1～7日以内',
    returnExchange: "返品・交換について",
    returnExchangeAvailable: "返品・交換の可否",
    returnExchangePolicy: 'お客様のご都合による返品・交換は受け付けておりません。',
    defectiveProductPolicy: '不良品については、直接販売者へお問い合わせください。',
    customerSupportPolicy: '販売者からの回答が得られない場合など、下記案内のとおりカスタマーサポートまでご連絡ください。お客様のご要望に応じて、適切な対応を行います。',
    shopDetailInfo: "ショップ情報",
    companyName: "販売業者",
    shopInfo: "ショップ情報",
    returnExchangeText1: "お客様都合による商品のキャンセル・返品は原則として承っておりません",
    returnExchangeText2: "ご注文した商品と異なる商品が届いた場合、または明らかに商品が破損している場合に限り、直ちに詳細をご連絡いただき、処理させていただきます",
    returnExchangeText3: "期限を過ぎてからのご連絡は対応致しかねます"
  },
  // 路由标题
  routeTitle: {
    cardAlbum: "自分のファイル",
    userProfile: "個人ページ",
    userPoster: "個人ポスター",
    deckPoster: "デッキポスター",
    deckShare: "デッキシェア",
    searchRanking: "ランキング検索",
    addBankCard: "銀行口座を追加",
    packShare: "パックシェア",
    packPoster: "パックポスター",
    cardPoster: "カード詳細ポスター",
    cardDetail: "カード詳細",
    shop: "店舗",
    wish: "ウィッシュリストシェア",
    wishPoster: "ウィッシュリストポスター",
    shopPoster: "店舗ポスター",
    dynamicShare: "投稿シェア",
    aiNews: "NEWS",
    dynamicPoster: "投稿ポスター",
    activity: "イベント",
    activityPoster: "イベントポスター",
    cardCarving: "シャドーボックス",
    activityRules: "大会規約",
    activityInvite: "友達を招待して投票",
    activitySignup: "エントリー情報入力",
    activityWorkDetail: "作品詳細",
    activityRankRecord: "大会ランキング",
    specialLaw: "ショップ情報",
    notFound: "ページが存在しません",
    activityCenter: "キャンペーン情報",
    lotteryPoster: "抽選イベントチラシ",
    lottery: "抽選イベント",
    prizeList: "景品一覧",
    aiDeck: 'AI分析',
    exchangeCoupon: "クーポン",
    auctionShare: "オークションをシェア",
    auctionPoster: "オークション画像"
  },
  // 抽奖
  lottery: {
    rule: "規約",
    prize: "賞品",
    finalExplanation: "※本キャンペーンの解釈および最終的な判断はカドラバが行います。",
    viewDetails: "詳細を見る",
    activityList: "キャンペーン一覧",
    myParticipation: "参加状況・履歴",
    rules: "規約",
    iKnow: "確認しました",
    myPrize: "賞品",
    address: "配送先住所",
    prizeNotice: "当選おめでとうございます！賞品の受け渡しについては、カドラバの担当者よりご連絡いたしますので、しばらくお待ちください。",
    participate: "抽選に参加",
    soonToOpen: "まもなく\n結果発表",
    openResult: "結果確認",
    noPrize: "ハズレ",
    receivePrize: "受け取る",
    activitySoonStart: "開始まであと少し…",
    clickToParticipate: "今すぐ抽選応募しましょう！",
    waitingForResult: "結果発表までお待ちください〜",
    resultAnnounced: "結果発表！今すぐチェック →",
    notWinning: "ハズレました…",
    congratulations: "当選おめでとう！",
    lotteryEnded: "抽選は終了しました〜",
    startTime: "開始時間：",
    drawTime: "結果発表時間：",
    prizeNotice2: "賞品を受け取るには、配送先住所の入力が必要です。\n発送時点で住所が未入力の場合、賞品は辞退されたものとみなされます。",
    keepTrying: "次こそは！あと少しで\n豪華賞品に手が届きそう…！",
    congratulationsPrize: "【{prize}】に当選しました！\n期限内に受け取ってください",
    claimPrizeReminder: "期限内に受け取ってください！",
    drawDate: "{time} 結果発表",
    confirm: "確認しました",
    edit: "編集する",
    updateApp: "当選者情報の入力には最新バージョンへのアップデートが必要です。\nアプリを更新の上、ご入力ください。",
    competitionQualification: "大会応募",
    pm_H5_luckyDraw_winning: "当選おめでとうございます！賞品のクーポンをアカウントに追加しました！獲得したクーポンは「マイページ」/「クーポン」からご確認いただけます。",
    pm_H5_luckyDraw_my_address: "配送先を登録"
  },
  // 兑换券
  exchangeCoupon: {
    pm_H5exchange_coupon_description: "詳細説明",
    pm_H5exchange_coupon_btn_not_started: "イベント開始までお待ちください",
    pm_H5exchange_coupon_btn_login: "先にログインしてください",
    pm_H5exchange_coupon_btn_no_usage_eligibility: "参加資格をお持ちでない",
    pm_H5exchange_coupon_btn_used: "クーポンを獲得しました",
    pm_H5exchange_coupon_btn_can_use: "こちらをタップして使用しください",
    pm_H5exchange_coupon_btn_ended: "キャンペーンはすでに終了しています",
    pm_H5exchange_coupon_anti_fraud_limit: "ご利用中の端末は既に本イベントに参加済みです。別の端末でお試しください。",
    pm_H5exchange_coupon_chooseShop: "ご利用店舗を選択してください",
    pm_H5exchange_coupon_cancellation_operation: "ご利用確認",
    pm_H5exchange_coupon_shop: "利用店舗",
    pm_H5exchange_coupon_show_this_page: "このページを",
    pm_H5exchange_coupon_carry_out: "にお見せいただき、利用確認を行ってください",
    pm_H5exchange_coupon_cannot_be_withdrawn: "使用後の取消はできません。スタッフが操作しますので、お客様ご自身で操作しないでください。",
    pm_H5exchange_coupon_confirm_usage: "タップして使用を確認してください",
    pm_H5exchange_coupon_confirm_usage2: "使用を確認しました",
    pm_H5exchange_coupon_confirm_close: "閉じる",
    pm_H5exchange_coupon_cancel_verification: "利用確認を取り消す"
  },
  // AI新闻
  aiNews: {
    time: "7×24時間",
    source: "情報元",
    pm_news_slogan: "リアルタイムでトレカ情報をチェック",
    pm_app_slogan: "トレカの新世界を見つけよう!",
    pm_news_details_share_poster_scan: "QRコードを読み取り、詳しい情報をゲット！",
    sourceText: "ユーザーアップロード"
  },
  // AI扫描介绍页
  aiScanIntroduce: {
    pm_batch_cards_indentify_tutorial_action_start: "今すぐ「AI画像検索」を体験する",
    pm_batch_cards_indentify_deck_tutorial_action_start: "今すぐデッキ画像をアップロード",
    pm_batch_cards_indentify_collection_tutorial_action_start: "今すぐ「撮影でマイカード追加」を体験する",
    pm_batch_cards_indentify_sell_tutorial_action_start: "今すぐ「撮影で商品出品」を体験する"
  },
  // 拍卖分享
  auction: {
    biddingRecords: "入札履歴",
    auctionInfo: "オークション情報",
    endTime: "終了時間",
    startingPrice: "開始価格",
    deposit: "保証金",
    productDescription: "商品説明",
    noDescription: "説明なし",
    purchaseTip: "ご購入の注意：中古品は7日間無条件返品交換の対象外です",
    sellerInfo: "出品者情報",
    area: "地域",
    ago: '前',
    minutesAgo: '{n}分',
    hoursAgo: '{n}時間',
    daysAgo: '{n}日',
    followers: "フォロワー",
    turnover: "取引量",
    avgShipTime: "平均発送時間",
    startTime: "開始時間",
    distanceEndTime: "終了まで",
    endTimeText: "終了",
    completedLabel: "落札：",
    highestBid: "最高入札額",
    auctionEnds: "オークションは終了しました",
    shareAt: "シェア日時:",
    leading: "最高額入札者",
    out: "落札できず",
    winnerMessage: "{username} さんが {price} で落札されました。おめでとうございます！",
    transactionPrice: "落札価格",
    status: "状態.",
    currentPriceLabel: "Current Price:",
    placeBid: "Place Bid",
    year: "年",
    month: "月",
    day: "日",
    hour: "時",
    minute: "分",
    dayCountdown: "日",
    second: "秒",
    soldAt: "落札日時",
    auctionDeleted: "オークションは削除されました",
  },
  // ai卡组
  aiDeck: {
    // 战力图谱
    // 宝可梦
    locale_pkm_damage_output: "攻撃",
    locale_pkm_search_consistency: "サーチ",
    locale_pkm_draw_power: "ドロー",
    locale_pkm_disruption: "妨害",
    locale_pkm_durability: "耐久",
    locale_pkm_versatility: "柔軟性",
    // 游戏王
    locale_ygo_combo_potential: "展開能力",
    locale_ygo_handtrap_resilience: "手札誘発の対応力",
    locale_ygo_versatility: "妥協と柔軟性",
    locale_ygo_board_breaking_power: "盤面処理能力",
    locale_ygo_resource_looping: "リソース持続力",
    locale_winning_keys: "主要戦術",
    locale_meta_fit: "環境適応度",
    locale_main_play: "主な遊び方",
    locale_gameplay_first_turn: "自分が先攻",
    locale_gameplay_second_turn: "自分が後攻",
    locale_counter_guide: "対策ガイド",
    locale_counter_guide_title: "対策ガイド",
    locale_counter_guide_opponent_first: "相手が先攻",
    locale_counter_guide_opponent_second: "相手が後攻",
    locale_card_analysis: "カード解析",
    locale_starting_approach: "初手展開ルート",
    locale_phase_management: "序盤・中盤・終盤攻略",
    locale_comeback_tactics: "不利状況対策",
    pm_deck_diagnosis_details_main_issue: "主な問題点",
    locale_power_chart: "Tier表",
    locale_surrender_text: "この状況になったら、サレンダー してもいいよ",
    locale_investment_number: "投入数",
    locale_ai: "AI",
    locale_deck_power_chart: "デッキTier表",
    locale_my_decks_ai_btn_text: "デッキをアップロードして、専用分析を取得",
    locale_my_decks_ai_btn_tag_text: "新規ユーザーは無料！（時間制限あり）",
    // AI卡组分析-卡牌列表-心愿单
    locale_ai_add_to_wishlist: "追加",
    locale_mainstream_matchups: "上位デッキへの対応",
    locale_optimizations: "調整の方向性",
    pm_deck_diagnosis_ratingLevel_S: "S級",
    pm_deck_diagnosis_ratingLevel_A: "A級",
    pm_deck_diagnosis_ratingLevel_B: "B級",
    pm_deck_diagnosis_ratingLevel_C: "C級",
    pm_deck_diagnosis_details_analyzingTime: "AI分析時間",
    pm_deck_diagnosis_details_share_poster_scanqrcode: "QRコードを読み取り 詳細分析をチェック",
    pm_deck_diagnosis_details_share_poster_userDeck_slogan: "あなたのデッキを「専門的に診断」",
    pm_deck_diagnosis_details_share_poster_topDeck_slogan: "環境デッキを徹底解析",
    pm_deck_diagnosis_details_share_poster_strategy: "先攻/後攻別の回し方",
    pm_deck_diagnosis_details_share_poster_suggestions: "デッキ強化のアドバイス",
    pm_deck_diagnosis_details_share_link_bottom_button: "詳細はアプリでチェック"
  }
};